import { render, staticRenderFns } from "./identical_main.vue?vue&type=template&id=794fea82&scoped=true&"
import script from "./identical_main.vue?vue&type=script&lang=js&"
export * from "./identical_main.vue?vue&type=script&lang=js&"
import style0 from "./identical_main.vue?vue&type=style&index=0&id=794fea82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794fea82",
  null
  
)

export default component.exports